import React from "react"
import { NavLink } from "react-router-dom"
import { NavbarBrand, NavItem } from "reactstrap"
import PropTypes from "prop-types"

import { Header as HeaderComponent } from "@swipesense/layout"

import Logo from "../Logo/Logo.svg"

import "./Header.scss"

class Header extends React.PureComponent {
  render() {
    const links = this.props.applications && [
      ...this.props.applications,
      {
        text: "Change Password",
        url: process.env.REACT_APP_AUTH_DOMAIN + "/users/settings",
      },
      {
        text: "Log Out",
        url: process.env.REACT_APP_AUTH_DOMAIN + "/users/sign_out",
      },
    ]

    return this.props.loading ? (
      <HeaderComponent logo={Logo} />
    ) : (
      <HeaderComponent
        logo={Logo}
        homeLink="/"
        homeLinkTag={NavbarBrand}
        initials={this.props.initials}
        navLinks={
          this.props.navLinks &&
          this.props.navLinks.map((link, i) => (
            <NavItem className="nav-item" key={i}>
              <NavLink
                to={link.path}
                key={link.path}
                className="nav-link"
                activeClassName="active"
              >
                {link.label}
              </NavLink>
            </NavItem>
          ))
        }
        startElements={
          this.props.facilityName
            ? [
                <div key={this.props.facilityName}>
                  {this.props.facilityName}
                </div>,
              ]
            : []
        }
        userNavLinks={
          links &&
          links.map(link => (
            <a href={link.url} key={link.url}>
              {link.text}
            </a>
          ))
        }
      />
    )
  }
}

Header.propTypes = {
  loading: PropTypes.bool,
  facilityName: PropTypes.string,
  navLinks: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
      path: PropTypes.string.isRequired,
    })
  ),
  initials: PropTypes.string,
  applications: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ),
}

export default Header
